// extracted by mini-css-extract-plugin
export default {"numberInput":"NumberInputControlled_numberInput__f62z3","wrapper":"NumberInputControlled_wrapper__YNktM"};